__turbopack_context__.v({
  "burger": "Burger-module-scss-module__TWKW1a__burger",
  "root": "Burger-module-scss-module__TWKW1a__root",
});
